/*
 * iLOLA Recharge price guard v3 (Oct 8, 2026)
 * Why: on the Canada / UK / Australia stores, for European visitors and on wholesale (B2B)
 * catalogues, the Recharge subscription widget replaces the correct local price with the
 * US/base price (e.g. Canada shows $18.00 instead of $21.00). Checkout still charges the
 * correct Shopify price, so the page was showing a price the customer would not be charged.
 * This reads Shopify's own product data (always market / catalogue correct, and the
 * same price checkout uses) and puts those prices back into the widget and the
 * product price. It does nothing for US retail visitors.
 *
 * v3 (Oct 8): uses the market's own currency symbol and number format (UK shows GBP, Europe
 *  shows EUR; v2 kept Recharge's "$") and also runs for any visitor outside the US, including
 *  Europe visitors on the main address.
 *
 * v2 changes (stops the visible price "fight"):
 *  1. The main price spans are taken away from Recharge (its marker class is swapped for
 *     a data attribute) so Recharge stops rewriting them with the US price.
 *  2. Prices are hidden for a moment while the first correct values are fetched
 *     (never longer than 2.5s), so the US price is never seen.
 *  3. Corrections run immediately (before the browser paints) instead of after a delay,
 *     with a safety brake that falls back to a short delay if something keeps fighting.
 * To remove: delete the <script> line for this file in snippets/ilola-customer-state.liquid.
 */
(function () {
  if (window.__ilolaRcPriceGuard) return;
  window.__ilolaRcPriceGuard = true;

  var root = '';
  try { root = (window.Shopify && Shopify.routes && Shopify.routes.root) || ''; } catch (e) {}
  if (!root) {
    var m = /^\/([a-z]{2}-[a-z]{2})(\/|$)/i.exec(location.pathname);
    root = m ? '/' + m[1] + '/' : '/';
  }
  var prefix = root.replace(/\/$/, '');
  function isB2B() {
    try { return !!(window.iLOLA_customerState && window.iLOLA_customerState.b2b); } catch (e) { return false; }
  }
  var hm = /\/products\/([^\/?#]+)/.exec(location.pathname);
  if (!hm) return;
  var handle = hm[1];
  function outsideUS() {
    try {
      var c = window.Shopify && Shopify.currency && Shopify.currency.active;
      var k = window.Shopify && Shopify.country;
      return (c && c !== 'USD') || (k && k !== 'US');
    } catch (e) { return false; }
  }
  if (root === '/' && !isB2B() && !outsideUS()) return;

  var HOOK = 'recharge-inner-most-price';
  var product = null, loading = false, timer = null, applying = false, released = false;
  var burst = 0, burstStart = 0, slowMode = false;

  // Hide prices until the first correct values are in (failsafe: 2.5s).
  var styleEl = null;
  try {
    styleEl = document.createElement('style');
    styleEl.textContent = 'html.ilola-rc-hold .rc-widget .rc-option__price,html.ilola-rc-hold [data-ilola-price]{visibility:hidden!important}';
    document.head.appendChild(styleEl);
    document.documentElement.classList.add('ilola-rc-hold');
  } catch (e) {}
  function release() {
    if (released) return;
    released = true;
    try { document.documentElement.classList.remove('ilola-rc-hold'); } catch (e) {}
  }
  setTimeout(release, 2500);

  // Money formatting: copy the theme's own format (symbol and separators) from a price the
  // server rendered and Recharge does not touch (the "compare at" price, e.g. "£0.00" / "€0,00").
  var tpl = null;
  function learnFormat() {
    if (tpl) return tpl;
    var els = document.querySelectorAll('.price__sale s.price-item, .price s.price-item, s.price-item--regular');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').replace(/\s+/g, ' ').trim();
      var m = /^(\D*?)(\d[\d.,\s]*\d|\d)(\D*)$/.exec(t);
      if (m && /[.,]\d{2}$/.test(m[2])) {
        tpl = { prefix: m[1], suffix: m[3], dec: m[2].charAt(m[2].length - 3), group: m[2].charAt(m[2].length - 3) === ',' ? '.' : ',' };
        return tpl;
      }
    }
    return null;
  }
  function money(cents) {
    var f = learnFormat();
    var whole = Math.floor(cents / 100), frac = ('0' + (cents % 100)).slice(-2);
    if (!f) {
      try {
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, f.group);
    return f.prefix + w + f.dec + frac + f.suffix;
  }
  function setNum(el, cents) {
    if (!el) return;
    var t = el.textContent;
    if (!/\d/.test(t) || t.length > 24) return;
    var next = money(cents);
    if (next !== t.trim()) el.textContent = next;
  }
  function claimSpans() {
    // Take the main price spans away from Recharge: swap its marker class for ours.
    var found = document.querySelectorAll('[class*="' + HOOK + '"]');
    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      el.setAttribute('data-ilola-price', '1');
      var cls = (el.getAttribute('class') || '').split(/\s+/).filter(function (c) { return c.indexOf(HOOK) === -1; });
      el.setAttribute('class', cls.join(' '));
    }
    return document.querySelectorAll('[data-ilola-price]');
  }
  function currentVariantId() {
    var u = null;
    try { u = new URL(location.href).searchParams.get('variant'); } catch (e) {}
    var inp = document.querySelector('product-info form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return (inp && inp.value) || u || null;
  }
  function apply() {
    if (!product || applying) return;
    applying = true;
    var ok = false;
    try {
      var vid = String(currentVariantId() || '');
      var v = null;
      for (var i = 0; i < product.variants.length; i++) { if (String(product.variants[i].id) === vid) v = product.variants[i]; }
      if (!v) v = product.variants[0];
      var onetime = v.price;
      var sub = null;
      var widget = document.querySelector('.rc-widget');
      var useSub = false;
      if (widget) {
        var sel = widget.querySelector('select.rc_widget__option__plans__dropdown, select.rc-selling-plans__dropdown, .rc-selling-plans select');
        var planId = sel && sel.value ? String(sel.value) : '';
        var allocs = v.selling_plan_allocations || [];
        for (var a = 0; a < allocs.length; a++) {
          if (planId && String(allocs[a].selling_plan_id) === planId) sub = allocs[a].price;
        }
        if (sub === null && allocs.length) sub = allocs[0].price;
        setNum(widget.querySelector('.rc-option__onetime .rc-option__price'), onetime);
        if (sub !== null) setNum(widget.querySelector('.rc-option__subsave .rc-option__price'), sub);
        var subRadio = widget.querySelector('.rc-option__subsave input[type="radio"]');
        useSub = !!(subRadio && subRadio.checked) && sub !== null;
        ok = true;
      }
      var shown = useSub ? sub : onetime;
      var spans = claimSpans();
      for (var s = 0; s < spans.length; s++) setNum(spans[s], shown);
      if (spans.length && !widget) ok = true; // product without a subscription widget
    } catch (e) {}
    applying = false;
    if (ok) release();
  }
  function schedule() {
    // Fast path: correct immediately (before paint). If we keep being re-triggered
    // (something is fighting us), drop to a 40ms delay so we can never spin.
    var now = Date.now();
    if (now - burstStart > 1000) { burstStart = now; burst = 0; slowMode = false; }
    burst++;
    if (burst > 25) slowMode = true;
    if (!slowMode) { apply(); return; }
    if (timer) return;
    timer = setTimeout(function () { timer = null; apply(); }, 40);
  }
  function load() {
    if (product || loading) return;
    loading = true;
    fetch(prefix + '/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { loading = false; if (p && p.variants) { product = p; schedule(); } })
      .catch(function () { loading = false; });
  }
  function start() {
    claimSpans();
    load();
    try {
      new MutationObserver(function () { if (!applying) schedule(); })
        .observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'checked', 'class'] });
    } catch (e) {}
    document.addEventListener('change', function () { schedule(); }, true);
    document.addEventListener('click', function () { setTimeout(schedule, 60); setTimeout(schedule, 400); }, true);
    window.addEventListener('load', function () { schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
